// extracted by mini-css-extract-plugin
export default {"root":"mimic___style_root__l+8RO","shortcutsBox":"mimic___style_shortcutsBox__Ptad+","supportingText":"mimic___style_supportingText__humzm"};